import { Link, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import MarketingLayout from '../components/MarketingLayout';

/** Custom 404 — shown for any unknown route inside the SPA. */
export function NotFoundPage() {
  const location = useLocation();
  // Scroll to top on mount
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <div className="min-h-screen flex flex-col bg-[#090c16] text-white">
      <header className="fixed inset-x-0 top-0 z-50">
        <div className="bg-[#080c16]/80 backdrop-blur border-b border-[#1f2640]/40">
          <div className="mx-auto w-full max-w-[1280px] px-6 flex h-[72px] items-center justify-between">
            <Link to="/" aria-label="Funder Pro" className="flex shrink-0 items-center">
              <img src="/cloned/wp-content/uploads/2024/10/Logo.svg" alt="Funder Pro" className="h-9 w-auto md:h-10" />
            </Link>
            <Link to="/" className="rounded-2xl border-2 border-[#345ffb] bg-[#080c16] px-5 py-2 text-sm font-bold text-white transition-colors hover:bg-[#345ffb]/15">
              ← Back home
            </Link>
          </div>
        </div>
      </header>
      <main className="flex-1 pt-[72px]">
        <div className="container-x py-24 text-center">
          <p className="text-7xl font-black text-line-light">404</p>
          <h1 className="mt-4 text-3xl font-bold text-white">Page not found</h1>
          <p className="mx-auto mt-4 max-w-md text-base text-muted-2">
            The page <code className="rounded bg-bg-deep px-1.5 py-0.5 text-accent-soft">{location.pathname}</code> doesn’t exist or has been moved.
          </p>
          <div className="mt-8 flex flex-wrap justify-center gap-3">
            <Link to="/" className="rounded-2xl bg-accent px-6 py-3 text-base font-bold text-white shadow-[0_12px_30px_-10px_rgba(52,95,251,0.8)] transition-colors hover:bg-accent/90">Go home</Link>
            <Link to="/contact-us" className="rounded-2xl border-2 border-line px-6 py-3 text-base font-bold text-white transition-colors hover:bg-white/5">Contact support</Link>
          </div>
        </div>
      </main>
    </div>
  );
}
